var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4715 17.1419C12.4 17.7277 12.3789 18.3042 12.2191 18.9005C11.9645 19.7505 11.2987 20.2704 10.5803 20.2494C10.2395 20.2578 9.75986 20.0503 9.43694 19.7788L5.67029 16.7195H3.57187C2.55999 16.7195 1.8784 16.0299 1.74061 14.8938C1.54391 13.4956 1.56285 10.9698 1.74061 9.54336C1.8784 8.55817 2.55999 7.78156 3.57187 7.78156H5.67029L9.35911 4.77464C9.68202 4.5011 10.2395 4.24327 10.5803 4.25061C11.2987 4.22965 11.9645 4.75054 12.2191 5.59948C12.3611 6.14237 12.4 6.77331 12.4715 7.35918C12.643 8.72901 12.643 15.772 12.4715 17.1419Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.4436 7.06055C17.3516 8.36655 17.8966 10.1185 17.8966 12.0685C17.8966 14.0185 17.3516 15.7695 16.4436 17.0755",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.8745 4C21.3375 6.104 22.2155 8.926 22.2155 12.068C22.2155 15.21 21.3375 18.033 19.8745 20.137",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesIcon);
export default __webpack_public_path__ + "static/media/updatesIcon.5c85d7bd4b5e97dfad933483844dd459.svg";
export { ForwardRef as ReactComponent };